import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';

import {analyticsEvent, analyticsPageView} from '../_common/AnalyticsManager';
import ApiV0 from '../services/ApiV0';
import './CHome.css';
import {GG_CATEGORY} from "../services/constant";
import {CHomeMessage} from "./CHomeMessage";
import CWhoContent from "../officials/CWhoContent";
import {CHomeBestListings} from "./CHomeBestListings";
import ScrollBanner from "./ScrollBanner";
import {renderLoader} from "../_common/CCommonUi";
import {isSet} from "../services/commonUtil";
import CUtils from "../services/CUtils";
import CErrorMessage from "../_common/CErrorMessage";
import CEtsyReviewsBanner from "./CEtsyReviewsBanner.js";

const currentPath = window.location.pathname;
let initialLoading = false;

export default withTranslation('common')(class CHome extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            homeData: null,
            wip: true
        };
    }

    componentDidMount() {
        const {t} = this.props;
        // DEBUG // console.log("CHome::componentDidMount", this.state.listings)
        document.title = t('home.title');
        analyticsPageView('home - ' + currentPath);
        if (initialLoading === false) {
            this.doLoadHomeData();
            initialLoading = true;
        }
    }

    doLoadHomeData() {
        const {t} = this.props;
        const evt = "home get";
        analyticsEvent(GG_CATEGORY.LISTING, evt, evt, 0);
        ApiV0.getHomeData()
            .then(homeData => {
                this.setState({
                    homeData: homeData,
                    wip: false,
                    errorMessage: null,
                    infoMessage: null,
                });
            })
            .catch(getError => {
                const getErrorMessage = CUtils.userErrorOf("home", t, getError);
                const errorMessage = `${t('home.searchError')}  ${getErrorMessage}`;
                console.error(errorMessage);
                this.setState({wip: false, errorMessage});
            });
    }

    render() {
        const lang = ApiV0.getLang();
        const {t, me, sections} = this.props;
        const title = t('ch.home');
        const {errorMessage, wip, homeData} = this.state;
        if (wip) {
            return renderLoader();
        } else if (homeData === null && isSet(errorMessage)) {
            return <CErrorMessage msg={errorMessage}/>;
        }

        const homeMessage = me?.homeMessage ? me?.homeMessage[lang] : null
        return (
            <div id="listingsList" className="chome"
                 itemScope
                 itemType="https://schema.org/ItemList"
                 ref={(input) => {
                     this.chome = input;
                 }}>
                <span className="hidden" itemProp="name">{title}</span>
                <CHomeMessage message={homeMessage}/>
                <CErrorMessage msg={errorMessage}/>
                <CHomeBestListings sectionTitle={t("ch.newListings")}
                                   listings={homeData?.whatsNewListings}/>
                <CWhoContent/>
                <CHomeBestListings sectionTitle={t("ch.heartThrob")}
                                   listings={homeData?.heartThrobListings}/>
                <CHomeBestListings sectionTitle={t("ch.bestSellers")}
                                   listings={homeData?.bestSellersListings}/>
                {sections?.length > 0 && (<>
                    <h2 className="alignCenter">{t("ch.sectionsScrollBanner")}</h2>
                    <ScrollBanner sections={sections}/>
                </>)}
                <CEtsyReviewsBanner reviews={homeData?.etsyReview}/>
            </div>
        );
    }

})